const RouteMessageSent = () => {
    return <div className="message-sent-parent">
        <div className="illustration"></div>
        <h2>Message Sent</h2>
        <p>Your message was sent successfuly. We will reply as soon as we can</p>
        <a href="/" className="section-btn african-but">GO BACK</a>
    </div>
}
export default RouteMessageSent;